"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highLightTime = highLightTime;
var themes_1 = require("../../../themes");
function highLightTime(elementToScroll, invert) {
    elementToScroll.scrollIntoView({ behavior: "auto" });
    // elementToScroll.style.backgroundColor = invert ? colors.greyColor70 : colors.greyColor10;
}
